// Lead-capture entry points. The retired lead and sample-report modals are
// gone: every "Join", "Start free" and "Download a sample report" action now
// opens App sign-up.
// Public API:
//   window.openLeadModal(kind, sourceOrOpts?) — navigates to App sign-up
//   window.closeLeadModal()                    — no-op, kept for old callers
//   window.openSampleReport(source?)           — navigates to App sign-up
//   window.onContactSubmit(payload)            — installed by api-client.js (POST /api/marketing/contact)

import { appUrl } from './app-origin.js';
import React from 'react';

// Side-effect import: registers window.on*Submit hooks so the contact form
// POSTs to Cloudflare Pages Functions backed by D1.
import './api-client.js';
// Side-effect import: wraps every visible "ScopeWorth" text occurrence in
// <strong class="sw-brand"> across the whole site.
import './boldify-brand.js';

function openSignUp() {
  window.location.href = appUrl('/sign-up');
}

if (typeof window !== 'undefined') {
  window.openSampleReport = openSignUp;
}

// =============================================================
// Modal root
// =============================================================
export function ModalRoot() {
  React.useEffect(() => {
    window.openLeadModal = openSignUp;
    window.closeLeadModal = () => {};
    return () => { window.openLeadModal = null; window.closeLeadModal = null; };
  }, []);
  return null;
}

if (typeof window !== 'undefined') window.ModalRoot = ModalRoot;
